export type BlogProductJourney = {
  href: string;
  label: string;
  description: string;
};

const PRODUCT_PATH =
  /^\/chat-bridge\/(?:en\/)?(?:landing|features|pricing|terms|about|security|support|privacy|whatsapp|instagram|telegram|google-chat)\/?$/;

export function isGaiaiBlogProductPath(href: string): boolean {
  return PRODUCT_PATH.test(href);
}

// Editorial pilot: each link points to a product page that explains the
// relevant capability or limitation. The article itself remains the source
// for the broader topic, not a product claim.
const PILOT_JOURNEYS: Record<string, BlogProductJourney> = {
  "whatsapp-bot-kurma-rehberi": {
    href: "/chat-bridge/whatsapp",
    label: "WhatsApp görüşmesi ve ekip devri seçeneklerini inceleyin",
    description:
      "Mevcut kanal ve izin seçeneklerinin ürün tarafındaki açıklamasına geçin.",
  },
  "whatsapp-chatbot-hizmet-secimi": {
    href: "/chat-bridge/terms",
    label: "WhatsApp bağlantı yöntemi ve hizmet sınırlarını okuyun",
    description:
      "Sağlayıcı karşılaştırmanızda kullanabileceğiniz bağlantı ve kullanım koşullarını görün.",
  },
  "whatsapp-yapay-zeka-botu-ilk-30-gun": {
    href: "/chat-bridge/whatsapp",
    label: "İlk senaryonuz için kanal ve yetki seçeneklerini görün",
    description:
      "Ürünün anlattığı iş akışlarını kendi değerlendirme planınızla karşılaştırın.",
  },
  "kurumsal-yapay-zeka-cozumleri-rehberi": {
    href: "/chat-bridge/landing",
    label: "Müşteri konuşması ve ekip işi örneklerine bakın",
    description:
      "GAIAI Agents'ın bu iki kullanım alanını nasıl anlattığını inceleyin.",
  },
  "kurumsal-yapay-zeka-asistani-hizmet-secimi": {
    href: "/chat-bridge/features",
    label: "Bilgi kaynağı ve izinlerle ilgili örnek akışları inceleyin",
    description:
      "Belge, tablo ve erişim örneklerini ürün özellikleriyle karşılaştırın.",
  },
};

export function getBlogProductJourney(
  brandId: string,
  slug: string
): BlogProductJourney | null {
  if (brandId !== "gaiai") return null;
  return PILOT_JOURNEYS[slug] ?? null;
}
